import Main from './main.js';
import Header from './header.js';
import CustomDescription from './customDescription.js';
import Availability from './availability.js';
import CareApproach from './careApproach.js';
import Services from './services.js';
import Highlights from './highlights.js';
import Credentials from './credentials.js';
import WorkHistory from './workHistory.js';
import ProfileNotAvailable from './profileNotAvailable.js';
import metaData from './metaData.js';
import Review from './review.js';
import CaregiverFeedback from './caregiverFeedback.js';


export default {
  Main,
  Header,
  CustomDescription,
  Availability,
  CareApproach,
  Services,
  Highlights,
  Credentials,
  WorkHistory,
  Review,
  ProfileNotAvailable,
  CaregiverFeedback,
  metaData,
};
